import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';

class AddPurchaser extends React.Component {
  state = {
    name: '',
    error: '',
    load: false,
    message: '',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit() {
    let context = this;
    let name = this.state.name;
    if (name == '' || name == undefined || name == null) {
      context.setState({
        error: 'Enter the Purchaser Name!!!'
      })
      return;
    }
    context.setState({
      load: true,
      message: 'Add Purchaser!!!'
    })
    let data1 = { 'name': name }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/addpurchaser.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.getPurchaser();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false,
        });
      }
    });
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog
          fullScreen={fullScreen}
          open={this.props.addPurchaser}
          onClose={this.props.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle style={{width: 500}} id="responsive-dialog-title">{"Add Purchaser"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <form noValidate autoComplete="off">
                <TextField
                  id="outlined-name"
                  label="Purchaser Name"
                  value={this.state.name}
                  onChange={this.handleChange('name')}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </form>
              <center style={{color: 'red'}}>{this.state.error}</center>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="secoundary">
              Cancel
            </Button>
            <Button onClick={this.submit.bind(this)} color="primary" autoFocus>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AddPurchaser.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(AddPurchaser);
